<template>
    <div class="mapeamento-retoativo">
        <ModalLogDetalhadoMapeamento :datas="logDataModal" />
        <container-card id="filtroSincronizacao" icon="fa-sitemap" title="Selecione as opções de mapeamento.">
            <b-card>
                <el-form class="geral-form" ref="formMapeamentoRetroativo" :model="filtroModel" :rules="rules" size="small" label-position="top">
                    <el-row :gutter="10">
                        <SelectMarcas v-model="filtroModel.marcas" />
                        <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="6">
                            <el-form-item label="Tipo de Regime" prop="tipoDeRegime">
                                <select2 :options="options" name="tipoDeRegimeSelect" v-model="filtroModel.tipoDeRegime"></select2>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="6">
                            <el-form-item label="Data" prop="data" required>
                                <el-date-picker v-model="filtroModel.data"
                                    type="monthrange"
                                    range-separator="|"
                                    start-placeholder="Início"
                                    end-placeholder="Fim"
                                    format="MM/yyyy"
                                    size="small"
                                    class="w-100">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="12">
                            <el-form-item required :label="`Grupos${filtroModel.clusterBool ? ' (Cluster)' : ''}:`" label-for="gruposSelect" :prop="filtroModel.clusterBool ? 'clusterId' : 'grupoId'">
                                <div class="toogle-multiselect-cluster">
                                    <small class="label-toogle-cluster">{{ filtroModel.clusterBool ? 'Alterar para Grupos' : 'Alterar para cluster' }}&nbsp;&nbsp;</small>
                                    <el-switch v-b-popover.hover.top="'Alternar combo clusters/Grupos.'"
                                                v-model="filtroModel.clusterBool"></el-switch>
                                </div>
                                <div v-show="filtroModel.clusterBool == false">
                                    <custom-select-multiple
                                      v-model="filtroModel.grupoId"
                                      :url="$urls.GRUPOS"
                                    />
                                  </div>
                                <div v-show="filtroModel.clusterBool == true">
                                    <custom-select-multiple
                                      v-model="filtroModel.clusterId"
                                      :url="$urls.DRE_LISTA_CLUSTER"
                                    />  
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div slot="footer">
                    <div class="float-left btn-pesquisar">
                        <el-button v-if="temAcesso('Comparativo','Obter')" size="small" type="primary" icon="el-icon-search" @click="pesquisarSolicitacao">Pesquisar solicitações</el-button>
                        <el-button v-else size="small" type="primary" icon="el-icon-search" v-b-tooltip.hover title="Sem permissões" class="no-drop">Pesquisar solicitações</el-button>
                        <el-button size="small" icon="el-icon-brush" @click="limparCampos">Limpar</el-button>
                    </div>
                    <div class="float-right">
                        <el-button v-if="temAcesso('Comparativo','Salvar')" size="small" type="success" icon="el-icon-thumb" @click="solicitarComparativo">Solicitar mapeamento</el-button>
                        <el-button v-else size="small" v-b-tooltip.hover title="Sem permissões" class="no-drop" type="success" disabled icon="el-icon-thumb">Solicitar mapeamento</el-button> 
                    </div>
                </div>
            </b-card>

        </container-card>

        <container-card fixed id="comparativoGrid" icon="fa-th-list" title="Log de mapeamento.">
            <b-card>
                <el-table
                    class="p-table"
                    v-loading="tableLoading"
                    :data="mapeamentoDataTable"
                    style="width: 100%;"
                    stripe
                    border
                    size="mini">

                    <el-table-column
                        prop="grupos"
                        label="Grupo"
                        align="left">
                    </el-table-column>

                    <el-table-column
                        prop="inicio"
                        label="Início"
                        align="center"
                        width="150">
                    </el-table-column>

                    <el-table-column
                        prop="fim"
                        label="Fim"
                        align="center"
                        width="150">
                    </el-table-column>
                    
                    <el-table-column
                        label="Log completo"
                        min-width="125"
                        fixed="right"
                        width="150"
                    >
                        <template slot-scope="scope" v-if="scope.row">
                            <el-button round icon="el-icon-view" @click="mostrarLogsDetalhados(scope.row)" size="mini">Log Detalhado</el-button>
                        </template>
                    </el-table-column>

                    <el-table-column
                        fixed="right"
                        label="Status"
                        width="70"
                        align="center">
                        <template slot-scope="scope" v-if="scope.row">
                            <el-tooltip v-if="scope.row.status === 'Aguardando'" class="item" effect="dark" content="Status: Aguardando" placement="top-start">
                                <i class="fas fa-circle text-warning"></i>
                            </el-tooltip>
                            <el-tooltip v-if="scope.row.status === 'Processando'" class="item" effect="dark" content="Status: Processando" placement="top-start">
                                <i class="fas fa-circle text-primary"></i>
                            </el-tooltip>
                            <el-tooltip v-if="scope.row.status === 'Finalizado'" class="item" effect="dark" content="Status: Finalizado" placement="top-start">
                                <i class="fas fa-circle text-success"></i>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <br>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 30, 50, 100]"
                    :page-size="pagination.pageSize"
                    :current-page.sync="pagination.page"
                    layout="sizes, prev, pager, next"
                    background
                    class="text-center"
                    :total="pagination.total"
                    >
                </el-pagination>
            </b-card>
        </container-card>
    </div>
</template>

<script>
import ContainerCard from '@/components/shared/ContainerCard'
import ModalLogDetalhadoMapeamento from '@/views/Sincronizacao/ModalLogDetalhadoMapeamento'
import SelectMarcas from '@/components/shared/SelectMarcas'
import Select2 from '@/components/shared/Select2'

const filtroModel = () => {
    return {
        data: [],
        clusterBool: false,
        clusterId: [],
        grupoId: [],
        inicio: '',
        fim: '',
        marcas: [],
        tipoDeRegime: '1'
    }
}
export default {
    name: 'mapeamento-retroativo',
    components: {
        ContainerCard,
        Select2,
        ModalLogDetalhadoMapeamento,
        SelectMarcas
    },
    data() {
        return {
            filtroModel: filtroModel(),
            logDataModal: {},
            tableLoading: false,
            //logMapeamentoData: [],
            mapeamentoDataTable: [],
            logMapeamentoData: [],
            rules: {
                data: [
                    { required: true, message: 'Por favor, escolha um período', trigger: 'change' }
                ],
                grupoId: [
                    { type: 'array', required: true, message: 'Por favor, escolha um grupo', trigger: 'change' }
                ],
                clusterId: [
                    { type: 'array', required: true, message: 'Por favor, escolha um cluster', trigger: 'change' }
                ]
            },
            listas: {
                empresas: [],
                cluster: []
            },
            pagination: {
                page: 1,
                pageSize: 25,
                total: 0
            },
            options: [{
                id: 1,
                label: 'Competência'
            }, {
                id: 2,
                label: 'Data do Caixa'
            }]
        }
    },
    watch: {
        'filtroModel.data': function(val) {
            let hasVal = !this.isNullOrEmpty(val);

            this.filtroModel.inicio = hasVal ? this.moment(val[0]).format('YYYY-MM-DD') : ''
            this.filtroModel.fim = hasVal ? this.moment(val[1]).format('YYYY-MM-DD') : ''
        },
        'filtroModel.clusterBool': function(val) {
            let grupoRule = this.rules.grupoId[0]; 
            let clusterRule = this.rules.clusterId[0];
            
            grupoRule.required = val ? false : true;
            clusterRule.required = val ? true : false;
            
        },
        'filtroModel.grupoId'() {
            this.$refs['formMapeamentoRetroativo'].validateField('grupoId');
        },
        'filtroModel.clusterId'() {
            this.$refs['formMapeamentoRetroativo'].validateField('clusterId');
        },
    },
    methods: {
        mostrarLogsDetalhados(rowData){
            this.logDataModal = rowData
            this.$bvModal.show('modal-log-mapeamento-retroativo');
        },
        limparCampos() {
            this.filtroModel = filtroModel()
        },
        pesquisarSolicitacao() {
            const ctx = this
            ctx.$refs['formMapeamentoRetroativo'].validate((valid) => {
              if (!valid) {
                  ctx.$notify.error({
                    title: 'Validação',
                    message: `Por favor, preencha todos os campos obrigatórios`,
                    position:'top-left'
                  });
                  
                return;
              }

                ctx.getDataTable()
            });
        },
        // requests
        solicitarComparativo() {
            const ctx = this;
            ctx.$refs['formMapeamentoRetroativo'].validate((valid) => {
                if (!valid) {
                ctx.$notify.error({
                  title: 'Validação',
                  message: `Por favor, preencha todos os campos obrigatórios`,
                  position:'top-left'
                });
                return;
              }

                ctx.postSolicitarComparativo();
            });
        },
        async postSolicitarComparativo() { 
            try {
                this.tableLoading = true
                const response = await this.axios.post(this.$urls.SOLICITAR_COMPARATIVO, {
                    inicio: this.filtroModel.inicio,
                    fim: this.filtroModel.fim,
                    clusterBool: this.filtroModel.clusterBool,
                    clusterId: this.filtroModel.clusterId,
                    grupoId: this.filtroModel.grupoId,
                    marcas: this.filtroModel.marcas,
                    tipoDeRegime: this.filtroModel.tipoDeRegime
                });

                if(response.status !== 200) {
                    this.$notify.error({
                        title: 'Solicitar mapeamento retroativo',
                        message: `Não foi possível fazer sua solicitação`,
                        position:'top-left'
                    });
                    return
                }
                // this.mapeamentoDataTable = response.data
                this.getDataTable()

            } catch(err) {
                console.log('err: ',err)
                this.$notify.error({
                        title: 'Erro interno',
                        message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
                        position:'top-left'
                    });
            } finally {
                this.tableLoading = false
            }
        },
        async getDataTable() { 
            try {
                this.tableLoading = true
                const response = await this.axios.get(this.$urls.GET_GRID_COMPARATIVO, {
                    params:  {
                        inicio: this.filtroModel.inicio,
                        fim: this.filtroModel.fim,
                        Page: this.pagination.page,
                        PageSize: this.pagination.pageSize,
                        marcas: this.filtroModel.marcas.join(',')
                    }
                });

                if(response.status !== 200) {
                    this.$notify.error({
                        title: 'Solicitar mapeamento retroativo',
                        message: `Não foi possível fazer sua solicitação`,
                        position:'top-left'
                    });
                    return
                }
                this.pagination.total = response.data.total
                this.mapeamentoDataTable = response.data.comparativos

            } catch(err) {
                console.log('err: ',err)
                this.$notify.error({
                        title: 'Erro interno',
                        message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
                        position:'top-left'
                    });
            } finally {
                this.tableLoading = false
            }
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.pagination.page = 1
            this.getDetalhe()
        },
        handleCurrentChange(val) {
            this.pagination.page = val
            this.getDetalhe()
        },
    }
}
</script>

<style lang="scss">
.mapeamento-retroativo {
    position:relative;
}
</style>
